import React from 'react';
import { Icon } from '@dexma/ui-components';
import { StyledTabSideMenuConfiguration } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Common/style';
import i18n from 'asset/translation';

type TabSideMenuConfigurationProps = {
    withError: boolean;
    title: string;
};

const TabSideMenuConfiguration = ({ withError, title }: TabSideMenuConfigurationProps): JSX.Element => (
    <StyledTabSideMenuConfiguration>
        {title}
        {withError && (
            <Icon
                color='red'
                data-testid='icon-data-error'
                name='error'
                size={20}
                ariaLabel={i18n.t('dashboards.edit.ariaLabel.errorIcon')}
            />
        )}
    </StyledTabSideMenuConfiguration>
);

export default TabSideMenuConfiguration;
